export const Footer = () => (
  <footer className="mt-20 border-t border-stone-200 bg-stone-900 text-stone-300">
    <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-4 gap-8">
      <div className="md:col-span-2">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-9 h-9 rounded-lg bg-emerald-600 flex items-center justify-center text-white font-display font-extrabold">K</div>
          <span className="font-display font-extrabold text-lg text-white">Kedai<span className="text-emerald-400">Import</span></span>
        </div>
        <p className="text-sm text-stone-400 max-w-md leading-relaxed">
          Jembatan belanja grosir langsung dari ribuan supplier di China ke Indonesia. Cari pakai
          Bahasa Indonesia, bayar Rupiah, ambil di kedai terdekat. Kami bantu kirim sampai gudang
          & sampai ke tanganmu.
        </p>
      </div>
      <div>
        <h4 className="font-display font-semibold text-white mb-3 text-sm">Layanan</h4>
        <ul className="space-y-2 text-sm text-stone-400">
          <li>Belanja Grosir Import</li>
          <li>Jasa Kirim China-Indo</li>
          <li>Jaringan Kedai Lokal</li>
          <li>Edukasi Belanja Import</li>
        </ul>
      </div>
      <div>
        <h4 className="font-display font-semibold text-white mb-3 text-sm">Kenapa Kami</h4>
        <ul className="space-y-2 text-sm text-stone-400">
          <li>Kurs Bersaing</li>
          <li>Garansi Barang Sampai</li>
          <li>Pendampingan Kedai</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-stone-800 py-4 text-center text-xs text-stone-500">
      © 2026 KedaiImport — Bantu warga daerah belanja grosir dari China dengan mudah.
    </div>
  </footer>
);
